// Imports
import Vue from 'vue'
import Router from 'vue-router'
import Store from '@/store/index'
import { trailingSlash } from '@/util/helpers'
import {
  layout,
  route,
} from '@/util/routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    layout('Default', [
      route('Login'),
      route('Dashboard', null, 'dashboard'),

      // Contracts
      route('Contracts', null, 'contracts'),
      route('Contract Details', null, 'contracts/:id'),
      route('User Profile', null, 'profile'),
      route('Paused Alerts', null, 'paused-alerts'),
      route('IDP Certificates', null, 'idp-certs'),
      route('Software', null, 'software'),
      route('Problems', null, 'problems'),

      // Software
      route('Assyst Software', null, 'software/assyst/:id'),
      route('IPaaS Software', null, 'software/ipaas/:id'),
      route('Itom Software', null, 'software/itom/:id'),

      // Admin
      route('User Management', null, 'user-admin'),
      route('SQL Admin', null, 'sql-admin'),
      route('Administration', null, 'admin'),
    ]),
  ],
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/']
  const authRequired = !publicPages.includes(to.path)

  const twofactor_check = Store.getters['user/twoFactorCheck']
  const userDetails = Store.getters['user/loggedIn']
  const canEditUsers = Store.getters['user/canEditUsers']
  const canEditSettings = Store.getters['user/canEditSettings']

  const loggedIn = twofactor_check ? userDetails : false

  // Restrict access to the 'User Management' section
  if (to.path === '/user-admin/' && !canEditUsers) {
    return next('/dashboard/')
  }

  // Restrict access to the 'Admin' section
  if (to.path === '/admin/' && !canEditSettings) {
    return next('/dashboard/')
  }

  if (authRequired && !loggedIn) {
    return next({
      path: '/',
      query: { returnUrl: to.path },
    })
  }

  if (!authRequired && loggedIn) {
    return next({
      path: '/dashboard/',
      query: { returnUrl: to.path },
    })
  }

  return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
})

export default router
